import React from 'react'
import Register from '../Components/Login/Register'

const SignUp = () => {
  return (
    <div>
      <Register />
    </div>
  )
}

export default SignUp